exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-select{width:100%;padding-top:10px;padding-bottom:10px;height:40px;background-color:#f2f2f2;font-weight:400}.form-select-container .form-control{font-size:1rem}.form-control:focus{border-color:#ff80ff;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(255,100,255,.5)}.form-select.form-select-error,.form-select.form-select-error:focus{border:1px solid #dd0342}.form-select-container{margin-top:10px;margin-bottom:10px}.form-select-validation-error{color:#dd0342;font-size:.75rem;font-weight:400}.form-select-required-text{float:right;font-size:.5625rem;font-weight:400;text-transform:uppercase;color:#dd0342}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/form/FormSelect/FormSelect.scss
 ** module id = 1246
 ** module chunks = 0
 **/